




























































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import VueSlider from 'vue-slider-component'
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import ExpandButton from '@/components/ExpandButton.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { DownlinkService, curDownlinkService, RawDownlinkReq } from '@/services/DownlinkService';
import { curPref, Preferences } from '@/services/Preferences';
import {FilterUtil} from "@/util/FilterUtil";
import {Device, DeviceBusEventData} from '@/types/core';
import AbeewaySmartBadgeControl from "@/components/device/configuration/AbeewaySmartBadgeControl.vue";
import CustomSectionHeader from "@/components/CustomSectionHeader.vue";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import RisingHfControl from "@/components/device/configuration/RisingHfControl.vue";
import NsenControl from "@/components/device/configuration/nsen/NsenControl.vue";
import LixiaControl from "@/components/device/configuration/LixiaControl.vue";
import LinkBoxControl from './configuration/LinkBoxControl.vue';
import PowerPilotControl from './configuration/PowerPilotControl.vue';
import AbeewayPoleTiltControl from './configuration/AbeewayPoleTiltControl.vue';
import AbeewayCoverageControl from './configuration/AbeewayCoverageControl.vue';


@Component({
  components:{
    NsenControl,
    VueError,
    Success,
    SectionHeader,
    CustomSectionHeader,
    VueSlider,
    ExpandButton,
    AbeewaySmartBadgeControl,
    RisingHfControl,
    LixiaControl,
    PowerPilotControl,
    AbeewayPoleTiltControl,
    AbeewayCoverageControl,
    LinkBoxControl
  }
})
export default class UpdateConfig extends Vue {

  data() {
    return {
      localDevice: this.device
    }
  }

  error:string = '';
  success:string = 'well done';

  downlinkError:string = '';
  downlinkSuccess:string = '';

  @Prop({ default: () => {},  type: Object}) device!:Device;

  bus = new Vue();

  localDevice = this.device;

  aradFreqMinutes = curPref.retrieve('v3-update-config-arad-gradiator-uplink-freq', 15);
  nanoReportFreqMinutes = curPref.retrieve('v3-update-config-nanothings-report-freq', 60);
  nanoRecordFreqMinutes = curPref.retrieve('v3-update-config-nanothings-record-freq', 15);

  loraPort:number = 1;
  hexPayload:string= '';
  flushQueue:boolean = false;
  downlinkCounter:number = (this.device?.network?.loraWan?.downlinkCnt) || 1;
  validityTime:number = 60;
  
  httpBusy:boolean = false;
  advanced:boolean = false;
  filterUtil:FilterUtil = new FilterUtil();
  errorMsg:string = '';

  private downlinkService:DownlinkService = curDownlinkService;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  created() {
    this.bus.$on('close', () => {
      this.$emit('close');
    });
  }
  async mounted() {
    this.success = '';
    this.error = '';
  }

  async loadDevice() {

    const reply = await this.coreClient.getDevice({deviceId: this.$route.params.deviceId});

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.httpCode === 404)
      return this.$router.push({name:'assets'});

    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve device info: ${reply.errorMsg}`;

    this.localDevice = reply.device!;

    const deviceBusEventData:DeviceBusEventData = {
      deviceId: this.localDevice.deviceId,
    };

    this.bus.$emit('refresh-device', deviceBusEventData);
    this.bus.$emit('refresh', deviceBusEventData);
  }

  async updateAradUplinkFrequency() {
    
    this.httpBusy = true;
    this.downlinkError = '';
    this.downlinkSuccess = '';

    // we update our cached value
    curPref.store('v3-update-config-arad-gradiator-uplink-freq', this.aradFreqMinutes);

    const reply = await this.downlinkService.aradMeterUpdateUplinkFrequency(this.device.deviceId, this.aradFreqMinutes*60);

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to update device device configuration: ${reply.errorMsg}`;
    
    this.success = `Configuration downlink accepted successfully by the network server for device ${this.device.deviceId}`;

    setTimeout( () => { this.$emit('close'); }, 5000)
    
  }

  async updateNanoUplinkFrequency() {
    
    // we do some data validation first
    if(this.nanoReportFreqMinutes % this.nanoRecordFreqMinutes !== 0)
      return this.error = `Report frequency must be a multiple of the record frequency`;

    if(this.nanoReportFreqMinutes / this.nanoRecordFreqMinutes > 7)
      return this.error = `Report frequency must be at most 7 times higher than the record frequency`;

    this.httpBusy = true;
    this.downlinkError = '';
    this.downlinkSuccess = '';

    // we update our cached value
    curPref.store('v3-update-config-nanothings-record-freq', this.nanoRecordFreqMinutes);
    curPref.store('v3-update-config-nanothings-report-freq', this.nanoReportFreqMinutes);
    
    const reply = await this.downlinkService.nanoUpdateFrequencies(this.device.deviceId, this.nanoRecordFreqMinutes, this.nanoReportFreqMinutes);

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to update device device configuration: ${reply.errorMsg}`;
    
    this.success = `Configuration downlink accepted successfully by the network server for device ${this.device.deviceId}`;

    setTimeout( () => { this.$emit('close'); }, 5000)
    
  }

  async sendRawDownlink(){

    this.httpBusy = true;

    let downlinkReq:RawDownlinkReq = {
      deviceId: this.device.deviceId,
      loraPort: this.loraPort,
      flushQueue: this.flushQueue,
      hexPayload: this.hexPayload.replace(/\s/g,''),
      validityTime: this.advanced && this.validityTime > 0 ? this.validityTime : undefined,
      downlinkCounter: this.advanced && this.downlinkCounter > 0 ? this.downlinkCounter : undefined,
    }

    const reply = await this.downlinkService.sendRawDownlink(downlinkReq);

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.downlinkError = `Unable to send downlink: ${reply.errorMsg}`;

    this.downlinkSuccess = `Downlink with payload ${this.hexPayload} sent to device: ${this.device.deviceId}`;

    setTimeout( () => { this.$emit('close'); }, 5000);
  }

  hexFormatter(value:string){
    let spacesRemoved = value.replace(/\s/g,"");
    let lastChar = spacesRemoved.substr(spacesRemoved.length-1)
    if (!/[a-f0-9]/.test(lastChar.toLowerCase())) {
      spacesRemoved = spacesRemoved.replace(lastChar,'')
    }
    return spacesRemoved.split('').map( (c:string, index:number) => (index % 2 !== 0) ? c + ' ' : c).join('').trim().toUpperCase();
  }

  toggleAdvanced(){
    this.advanced = !this.advanced;
  }

  get canConfigure():boolean {
    return this.device.deviceType === 'aradGladiator';
  }

  get canUpdate():boolean {
    return !this.httpBusy;
  }

  get canUpdateNanothings():boolean {
    return !this.httpBusy && 
      this.nanoReportFreqMinutes % this.nanoRecordFreqMinutes === 0 &&
      this.nanoReportFreqMinutes / this.nanoRecordFreqMinutes <= 7
  }

  get canCancel():boolean {
    return !this.httpBusy;
  }

  get showAradControl():boolean {
    return this.device.deviceType === 'aradGladiator';
  }

  get showNanotagControl():boolean {
    return this.device.deviceType === 'nanothingsStatic';
  }

  get showAbeewaySmartBadgeControl():boolean {
    return this.device.deviceType === 'abeewaySmartBadge';
  }

  get showRisingHfControl():boolean {
    return this.device.deviceType === 'risingHf';
  }

  get showNsenControl():boolean {
    return this.device.deviceType?.startsWith('nsenMk2');
  }

  get showLixiaControl():boolean {
    return this.device.deviceType === 'lixiaDeltaPuk';
  }

  get showPowerPilotControl():boolean {
    return this.device.deviceType === 'powerPilot';
  }

  get showAbeewayPoleTiltControl():boolean {
    return this.device.deviceType === 'abeewayPoleTilt';
  }

  get showAbeewayCoverageControl():boolean {
    return this.device.deviceType === 'abeewayCoverage';
  }

  get showLinkBoxControl():boolean {
    return this.device.deviceType === 'linkBox';
  }

  cancel() {
    this.$emit('close');
  }



}

